function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "building"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m21 20h-2v-16c0-1.103-.897-2-2-2h-10c-1.103 0-2 .897-2 2v16h-2c-.552 0-1 .447-1 1s.448 1 1 1h18c.552 0 1-.447 1-1s-.448-1-1-1zm-14-16h10v16h-2v-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v4h-2zm6 16h-2v-4h2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 11,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 11,
  r: 1
})));

var Svg021Building = function Svg021Building(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg021Building, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/021-building.199ec65d.svg";
export { ForwardRef as ReactComponent };